export interface GenerateForms030Payload {
  reasonsForFiling: any[]
  personalData: Record<string, any>
  domicileRegistration: Record<string, any>
}

function cloneObject<T extends Record<string, any>>(value: unknown, fallback: T): T {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return fallback
  }

  return { ...value } as T
}

function cloneArray(value: unknown): any[] {
  if (!Array.isArray(value)) {
    return []
  }

  return value.map((item) => {
    if (item && typeof item === 'object' && !Array.isArray(item)) {
      return { ...item }
    }

    return item
  })
}

export function buildGenerateForms030Payload(input: any): GenerateForms030Payload {
  return {
    reasonsForFiling: cloneArray(input?.reasonsForFiling),
    personalData: cloneObject(input?.personalData, {}),
    domicileRegistration: cloneObject(input?.domicileRegistration, {}),
  }
}
